import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { roles } from "../../util/config/roles";
import { AppDispatch, AppState } from "../../store/configureStore";
import { getWorkerDetails, getWorkerProfileImage } from "../../store/slices/workerDetails";
import "./Avatar.css";
import React from "react";

// Define props interface
interface AvatarProps {
    className?: string;
}

const Avatar: React.FC<AvatarProps> = ({ className = "" }) => {
    const dispatch = useDispatch<AppDispatch>();
    const { isSuperAdmin } = roles();
    const isLoggedIn = useSelector((state: AppState) => state.users.auth.isLoggedIn);

    const firstName = useSelector((state: AppState) => state.entities.workerDetails.forRequesting.data?.FirstName || "");
    const lastName = useSelector((state: AppState) => state.entities.workerDetails.forRequesting.data?.LastName || "");
    const profileImage = useSelector((state: AppState) => state.entities.workerDetails.forRequesting.profileImage.src || "");

    // Combine effect for better performance, only for logged-in users
    useEffect(() => {
        if (!isLoggedIn || isSuperAdmin) return;

        if (!firstName) {
            dispatch(getWorkerDetails());
        }
        if (!profileImage) {
            dispatch(getWorkerProfileImage());
        }
    }, [isLoggedIn, firstName, profileImage, dispatch, isSuperAdmin]);

    // Memoize profile picture to avoid unnecessary function calls
    const profilePicture = useMemo(() =>
        profileImage || "./photo-placeholder.jpeg",
        [profileImage]
    );

    return (
        <div className={`navbar-user ${className}`}>
            {(firstName || lastName) && (
                <div className="navbar-userName">
                    {firstName && <div>{firstName}</div>}
                    {lastName && <div>{lastName}</div>}
                </div>
            )}
            <div className="img-profile-container">
                <img
                    className="img-profile rounded-circle"
                    src={profilePicture}
                    alt={`${firstName} ${lastName}`.trim() || "Profile"}
                    loading="lazy"
                />
            </div>
        </div>
    );
};

// Wrap with React.memo for performance
export default React.memo(Avatar);